import React, { FunctionComponent, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Profile from 'views/profile';
import Header from 'components/header/index';
import DashboardLink from 'components/DashboardLink/DashboardLink';
import LeftNavBar from 'components/leftNavBar/LeftNavBar';
import Styles from 'views/profile/landing/MenuLanding.module.scss';
import PrivacyPolicy from 'views/privacyPolicy/PrivacyPolicy';
import TermAndConditions from 'views/termAndConditions/TermAndConditions';
import Subscription from 'views/subscription';
import FeedBack from 'views/feedBack';
import Notifications from 'views/notifications';
import DateAndTime from 'views/dateAndTime';
import Currency from 'views/currency';
import InviteFriend from 'views/inviteFriend';
import ExplainerVideo from 'views/explainerVideo/ExplainerVideo';
import EmailNotifications from 'views/emailNotifications';

const MenuLanding: FunctionComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div>
      <Header />
      <div className="custom-container">
        <div className={Styles.mobileTopBar}>
          <button className={Styles.mobileMenuButton} onClick={toggleMenu} aria-label="Toggle menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <div className={Styles.mobileDashboardLink}>
            <DashboardLink iconClass="fas fa-chevron-left" cssClass="" />
          </div>
        </div>
        <div className={Styles.desktopDashboardLink}>
        <DashboardLink iconClass="fas fa-chevron-left" cssClass="mt-40 mb-45" />
        </div>
        <div className={`${Styles.menuLandingWrapper} ${menuOpen ? Styles.menuOpen : ''}`}>
          {menuOpen && <div className={Styles.menuOverlay} onClick={closeMenu} />}
          <div className={Styles.leftSide}>
            <LeftNavBar onLinkClick={closeMenu} />
          </div>
          <div className={Styles.rightSide}>
            <Switch>
              <Route exact path="/subscription">
                <Subscription />
              </Route>
              <Route exact path="/explainer-video">
                <ExplainerVideo />
              </Route>
              <Route exact path="/invite-friend">
                <InviteFriend />
              </Route>
              <Route exact path="/currency">
                <Currency />
              </Route>
              <Route exact path="/profile/edit">
                <Profile />
              </Route>
              <Route exact path="/date-and-time">
                <DateAndTime />
              </Route>
              <Route exact path="/notifications">
                <Notifications />
              </Route>
              <Route exact path="/email-notifications">
                <EmailNotifications />
              </Route>
              <Route exact path="/feedback">
                <FeedBack />
              </Route>
              <Route exact path="/terms-and-conditions">
                <TermAndConditions />
              </Route>
              <Route exact path="/privacy-policy">
                <PrivacyPolicy />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuLanding;
